"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasEveryPermission = exports.hasSomePermission = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const hasSomePermission = (required, has) => required.some((permission) => has.indexOf(permission) > -1);
exports.hasSomePermission = hasSomePermission;
const hasEveryPermission = (required, has) => required.every((permission) => has.indexOf(permission) > -1);
exports.hasEveryPermission = hasEveryPermission;
const Permission = ({ required, has, every, otherwise = null, children, }) => {
    const isAllowed = every
        ? exports.hasEveryPermission(required, has)
        : exports.hasSomePermission(required, has);
    return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: isAllowed ? children : otherwise }, void 0);
};
exports.default = Permission;
